import { useTranslation } from "react-i18next";
import React, { useEffect, useState } from "react";
import { Navigate, Outlet, useParams } from "react-router-dom";
import { apiGet } from "../api/client";
import { AuthMe } from "../types/auth";
import { A } from "../styles/appleClasses";

export default function RequireCompany() {
  const { t } = useTranslation();
  const { company_id } = useParams<{ company_id: string }>();
  const [me, setMe] = useState<AuthMe | null>(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    apiGet<AuthMe>("/auth/me")
      .then((u) => setMe(u))
      .finally(() => setLoading(false));
  }, []);

  if (loading) {
    return (
      <div className="w-full flex items-center justify-center py-10">
        <div className={`inline-flex items-center gap-2 ${A.body} text-gray-500`}>
          <span
            className="h-4 w-4 rounded-full border-2 border-gray-200 border-t-gray-500 animate-spin"
            aria-hidden="true"
          />
          {t("directory.common.loading")}
        </div>
      </div>
    );
  }

  const cid = company_id?.toString();
  const userCid = me?.company_id != null ? String(me.company_id) : undefined;

  // deny if user isn't allowed in this company (strict match)
  if (!cid || !userCid || cid !== userCid) {
    return <Navigate to="/login" replace />;
  }

  return <Outlet />;
}
